<template>
  <div
    class="text-center"
    style="min-width: 100%"
  >
    <v-dialog v-model="dialog">
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          large
          block
          v-on="on"
        >
          Loan Setup Terms
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Loan Setup Terms
        </v-card-title>

        <v-card-text>
          <p
            class="red--text"
            style="font-size: 20px"
          >
            **Please note that these are the original setup terms that were validated at the time
            the loan was created. Please review the loan's current status to ensure you are
            providing accurate information.
          </p>
          <v-data-table
            :headers="headers"
            :items="originalValues"
            :items-per-page="10"
            class="elevation-1"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'OriginalLoanSetup',
  props: {
    loanId: {
      type: Number,
      required: false,
      default: null,
    },
    loanType: {
      type: String,
      required: false,
      default: 'installment',
    },
  },
  data() {
    const tableHeaders = [
      { text: 'APR', value: 'apr' },
      { text: 'Initial Loan Amount', value: 'loan_amount' },
      { text: 'Finance Charge', value: 'til_finance_charge' },
      { text: 'Term', value: 'term' },
    ];

    return {
      dialog: false,
      headers: tableHeaders,
    };
  },
  computed: {
    ...mapState('loanProLoan', ['activeLoan']),
    originalValues() {
      const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return [{
        apr: this.activeLoan.loan_setup.apr,
        loan_amount: currencyFormatter.format(this.activeLoan.loan_setup.loan_amount),
        til_finance_charge: currencyFormatter.format(this.activeLoan.loan_setup.til_finance_charge),
        term: `${parseInt(this.activeLoan.loan_setup.loan_term, 10)} ${this.activeLoan.loan_setup.payment_frequency.split('.')[2]} Payments`,

        // Term: By Weekly [Payment Frequency] 52 [term] Payments

      }];
    },
  },
};
</script>
